<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import FormInputText from "../../widgets/FormInputText.svelte"
    import { getCountries, getCountry } from "../../../api"
    import MiniLoader from "../../widgets/MiniLoader.svelte"
    import { checkoutData } from "../../../store"
    import { initialLocale, langField } from "../../../i18n"
    import { maxInputLength, sameBillingAndDeliveryAddress } from "../../../../../api/hooks/config-client"

    export let hideHeadline = false

    const invalidate = () => {
        $checkoutData.stepsValid = 0
    }

    let shippingNote: string

    $: {
        shippingNote = ""
        let code = $checkoutData.deliveryAddress.countryCode
        if (code) {
            getCountry(code).then((c) => {
                if (langField(c.note, "")) {
                    shippingNote = langField(c.note, "")
                }
            })
        }
    }
</script>

<section>
    {#if !hideHeadline}
        <div class="section_headline">
            {#if sameBillingAndDeliveryAddress}
                {$_("checkout.delivery-and-billing-address")}
            {:else}
                {$_("checkout.shipping-address")}
            {/if}
        </div>
    {/if}
    <div class="row">
        <div class="col-md-6">
            <FormInputText
                name="delivery_firstname"
                placeholder="{$_('checkout.firstname')} / {$_('checkout.address-supplement')} ({$_(
                    'checkout.optional'
                )})"
                bind:value="{$checkoutData.deliveryAddress.firstname}"
                on:change="{invalidate}"
                maxlength="{maxInputLength.firstname}"
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_lastname"
                placeholder="{$_('checkout.lastname')} / {$_('checkout.company')}"
                bind:value="{$checkoutData.deliveryAddress.lastname}"
                required
                on:change="{invalidate}"
                maxlength="{maxInputLength.lastname}"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <!--
                <FormInputText
                    name="delivery_company"
                    placeholder="Unternehmen (optional)"
                    bind:value="{$checkoutData.deliveryAddress.company}"
                    on:change="{invalidate}"
                    maxlength="{maxInputLength.company}"
                />
                -->
        </div>
        <div class="col-md-10">
            <FormInputText
                name="delivery_street"
                placeholder="{$_('checkout.street')}"
                bind:value="{$checkoutData.deliveryAddress.street}"
                required
                on:change="{invalidate}"
                maxlength="{maxInputLength.street}"
            />
        </div>
        <div class="col-md-2">
            <FormInputText
                name="delivery_houseNumber"
                placeholder="{$_('checkout.house-number')}"
                bind:value="{$checkoutData.deliveryAddress.houseNumber}"
                required
                on:change="{invalidate}"
                maxlength="{maxInputLength.houseNumber}"
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_postcode"
                placeholder="{$_('checkout.postcode')}"
                bind:value="{$checkoutData.deliveryAddress.postcode}"
                required
                on:change="{invalidate}"
                pattern="{initialLocale == 'de' ? '^\\d{5}$' : undefined}"
                maxlength="{maxInputLength.postcode}"
            />
        </div>
        <div class="col-md-6">
            <FormInputText
                name="delivery_city"
                placeholder="{$_('checkout.city')}"
                bind:value="{$checkoutData.deliveryAddress.city}"
                required
                on:change="{invalidate}"
                maxlength="{maxInputLength.city}"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            {@html $_("checkout.delivery-country-notice-html")}<br /><br />
            <div class="select_holder no-label">
                <!-- svelte-ignore a11y-no-onchange -->
                <select
                    name="delivery_country"
                    bind:value="{$checkoutData.deliveryAddress.countryCode}"
                    required
                    on:change="{invalidate}"
                >
                    {#await getCountries({ valid_for_order: true }, "name." + initialLocale)}
                        <option value="{$checkoutData.deliveryAddress.countryCode}">
                            <MiniLoader />
                        </option>
                    {:then countries}
                        {#each countries.data as country}
                            <option
                                value="{country.code}"
                                selected="{country.code == $checkoutData.deliveryAddress.countryCode}"
                            >
                                {langField(country.name, "")}
                            </option>
                        {/each}
                    {/await}
                </select>
                <div class="placeholder_overlay">
                    {$_("checkout.country")}
                </div>
                <div class="right_overlay">
                    <ChevronDownIcon size="24px" />
                </div>
            </div>
            {#if shippingNote}
                <div class="note">
                    {@html shippingNote}
                </div>
            {/if}
        </div>
    </div>
</section>
